import { WSQueryConfig } from "@ws-react-query";
import {
  getPayablesSummary,
  ListPayablesRequest,
  PayablesSummaryResponse
} from "../../services/api/payments/payables";
import { WSServiceError } from "../../utils/serviceHelper";
import { useWSQuery } from "../helpers";
import { QUERY_PAYABLES_SUMMARY } from "./keys";

type UseQueryPayablesSummaryRequest = Omit<
  ListPayablesRequest,
  "page[mode]" | "page[size]" | "page[token]" | "page[resultSetId]"
>;

export const useQueryPayablesSummary = (
  request: UseQueryPayablesSummaryRequest,
  config?: WSQueryConfig<PayablesSummaryResponse, WSServiceError>
) => {
  return useWSQuery<PayablesSummaryResponse, WSServiceError>(
    [QUERY_PAYABLES_SUMMARY, request],
    () =>
      getPayablesSummary({
        ...request,
        "page[mode]": "cursor"
      }),
    config
  );
};
